<template lang="pug">
  .thumbnail
    // TODO: fix lazy loading
    // see: src/extensions/shop/components/CategoryProducts/Teaser.vue
    .observer
      lazy-component(@show="show")
        img(:src="image.src")
    figure.image(:style="style")
      img(
        :src="image.src"
        :class="{ loaded }"
      )
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Thumbnail',
  data: () => ({
    loaded: false
  }),
  props: {
    media: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 46
    },
    aspectRatio: {
      type: Number
    }
  },
  computed: {
    width() {
      let width;
      if (this.aspectRatio) width = this.hright * this.aspectRatio;
      else width = this.height * (this.media.image.width / this.media.image.height);
      return width;
    },
    style() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        'background-image': `url(${this.image.blurry})`
      };
    },
    image() {
      let image = this.media.image;

      let root = '';
      const endpoint = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}`;
      if (process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE;
      const base = endpoint + root + 'images/';

      let format = '';
      if (this.webpSupport) format = '&format=webp';

      return {
        src: `${base}${image.id}/${image.name}?fit&w=${this.width}&h=${this.height}${format}`,
        error: `${base}${image.id}/${image.name}?fit&w=${this.width}&h=${this.height}&preview=greyscale`,
        blurry: `${base}${image.id}/${image.name}?fit&w=${this.width}&h=${this.height}&preview=blur`
      };
    },
    ...mapGetters({
      webpSupport: 'webpSupport'
    })
  },
  methods: {
    show() {
      this.loaded = true;
      // setTimeout(() => this.loaded = true, 600)
    }
  }
};
</script>

<style lang="sass" scoped>
.observer
  display: absolute
  width: 0
  height: 0
  left: -300vw
.image
  @apply bg-gray-200
  overflow: hidden
  // border: 1px solid var(--color-primary)
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  img
    opacity: 0
    height: 100%
    width: 100%
    object-fit: contain
    transition: opacity .3s ease
    &.loaded
      opacity: 1
</style>
